import { cn } from "@/shadcn/lib/utils";
import React, { useState } from "react";

type CustomImgProps = {
  imgSrc: string;
  alt: string;
  className: string;
  loadingClass?: string;
  loadingClassSpan?: string;
  errorSource?: string;
  onClick?: () => void;
};

const CustomImg: React.FC<CustomImgProps> = ({
  imgSrc,
  alt,
  className,
  errorSource,
  loadingClass,
  loadingClassSpan,
  onClick,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <div className={cn("text-primary h-12 w-12 text-center", loadingClass)}>
          <span
            className={cn(
              "relative inline-block h-full w-full",
              loadingClassSpan
            )}
          >
            {/* Ensure the span is always a square */}
            <span className="border-primary animate-loading-ping absolute inset-0 m-auto aspect-square rounded-full border-1 opacity-0"></span>
            <span className="border-primary animate-loading-ping absolute inset-0 m-auto aspect-square rounded-full border-1 opacity-0 delay-1000"></span>
          </span>
        </div>
      )}
      <img
        src={imgSrc}
        alt={alt}
        className={`${className} ${isLoading ? "hidden" : ""}`}
        onClick={onClick}
        onLoad={() => setIsLoading(false)}
        onError={(e) => {
          setIsLoading(false);
          e.currentTarget.src = errorSource
            ? errorSource
            : "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWltYWdlLW9mZiI+PGxpbmUgeDE9IjIiIHgyPSIyMiIgeTE9IjIiIHkyPSIyMiIvPjxwYXRoIGQ9Ik0xMC40MSAxMC40MWEyIDIgMCAxIDEtMi44My0yLjgzIi8+PGxpbmUgeDE9IjEzLjUiIHgyPSI2IiB5MT0iMTMuNSIgeTI9IjIxIi8+PGxpbmUgeDE9IjE4IiB4Mj0iMjEiIHkxPSIxMiIgeTI9IjE1Ii8+PHBhdGggZD0iTTMuNTkgMy41OUExLjk5IDEuOTkgMCAwIDAgMyA1djE0YTIgMiAwIDAgMCAyIDJoMTRjLjU1IDAgMS4wNTItLjIyIDEuNDEtLjU5Ii8+PHBhdGggZD0iTTIxIDE1VjVhMiAyIDAgMCAwLTItMkg5Ii8+PC9zdmc+";
        }}
      />
    </>
  );
};
export default CustomImg;
